"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _styles = require("@material-ui/core/styles");

var _UserIcon = _interopRequireDefault(require("../User/UserIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  icon: {
    width: "36px",
    height: "36px",
    margin: "-6px"
  }
}));

const ButtonUser = (_ref) => {
  let onClick = _ref.onClick,
      expanded = _ref.expanded,
      forwardedRef = _ref.forwardedRef,
      props = _objectWithoutPropertiesLoose(_ref, ["onClick", "expanded", "forwardedRef"]);

  const classes = useStyles();
  return _react.default.createElement(_IconButton.default, {
    className: classes.root,
    onClick: onClick,
    "aria-expanded": expanded,
    ref: forwardedRef
  }, _react.default.createElement(_UserIcon.default, _extends({}, props, {
    className: classes.icon
  })));
};

var _default = ButtonUser;
exports.default = _default;
module.exports = exports.default;